import { render, staticRenderFns } from "./addDevice.vue?vue&type=template&id=b479f662&scoped=true&"
import script from "./addDevice.vue?vue&type=script&lang=js&"
export * from "./addDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b479f662",
  null
  
)

export default component.exports